import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onQuickAction, currentLesson = null }) => {
  const quickActions = [
    {
      id: 'explain',
      label: 'Explique este conceito',
      icon: 'MessageSquare',
      action: () => onQuickAction('explain', 'Pode explicar melhor este conceito que estou estudando?')
    },
    {
      id: 'quiz',
      label: 'Me teste',
      icon: 'HelpCircle',
      action: () => onQuickAction('quiz', 'Pode criar um quiz sobre este tópico?')
    },
    {
      id: 'related',
      label: 'Conteúdo relacionado',
      icon: 'BookOpen',
      action: () => onQuickAction('related', 'Mostre conteúdo relacionado a esta lição')
    },
    {
      id: 'summary',
      label: 'Resumo da lição',
      icon: 'FileText',
      action: () => onQuickAction('summary', 'Faça um resumo dos pontos principais desta lição')
    }
  ];

  return (
    <div className="p-4 border-t border-border bg-muted bg-opacity-30">
      <div className="mb-3">
        <h4 className="text-sm font-medium text-foreground mb-2">Ações rápidas</h4>
        {currentLesson && (
          <p className="text-xs text-muted-foreground font-caption">
            Contexto: {currentLesson}
          </p>
        )}
      </div>
      <div className="grid grid-cols-2 gap-2">
        {quickActions?.map((action) => (
          <Button
            key={action?.id}
            variant="outline"
            onClick={action?.action}
            iconName={action?.icon}
            iconPosition="left"
            iconSize={14}
            className="text-xs py-2 px-3 h-auto justify-start"
          >
            {action?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;